import {createReducer} from 'utils/reducer';
import {getDateTime} from 'utils/time';
import {getLastCompletion, generateRanges, generateStartRange, getWeekdayNumber} from 'utils/xps';
import '../../../sentry';
import ExperienceSampling from '../actions/ExperienceSampling';

const initialState = {
    samplings: {ids: []},
    ranges: [],
    questionnaires: {ids: []},
    loading: true,
};

export default createReducer(initialState, {
    [ExperienceSampling.update]: (state, samplings) => {
        try {
            if (!!samplings && samplings.length != undefined && samplings.length > 0) {
                window.Sentry.addBreadcrumbInfo("experiencesampling reducer", `call api/.../samplings completed, received samplings>questionnaires = ${
                    JSON.stringify(
                        samplings.flatMap(x => {
                            if (!!x.questionnaires && x.questionnaires.length != undefined && x.questionnaires.length > 0) {
                                return x.questionnaires.map(q => q.id);
                            } else {
                                return `questionnaires_in_sampling_${x.id} are empty`;
                            }
                        }))}
                    `);
            } else {
                window.Sentry.addBreadcrumbInfo("experiencesampling reducer", `call api/.../samplings completed, no samplings>questionnaires received`);
            }
        } catch (e) {
            window.Sentry.addBreadcrumbInfo("experiencesampling reducer", `call api/.../samplings completed, couldn't parse samplings ${e}`);
        }

        const now = new Date();
        const samplingData = {ids: []};
        const ranges = [];
        const questionnaireData = {ids: []};

        samplings.forEach(sampling => {
            const {id, start, end, startTime, endTime, questionnaires} = sampling;
            const startQuestionnaire = questionnaires.find(({isStart}) => isStart) || null;

            const startDate = getDateTime(start, startTime);
            const endDate = getDateTime(end, endTime);

            samplingData.ids.push(id);
            samplingData[id] = {
                id,
                start: startDate,
                end: endDate,
                questionnaires: questionnaires.map(({id}) => id),
            };

            const lastCompletion = startQuestionnaire !== null ? getLastCompletion(startQuestionnaire) : startDate;
            const periodQuestionnaires = questionnaires.filter(({isStart, weekday}) => {
                return isStart === false && ['ALL', getWeekdayNumber(now)].includes(weekday);
            });

            if (lastCompletion === null) {
                ranges.push(generateStartRange(sampling, startQuestionnaire, now));
            } else {
                periodQuestionnaires.forEach(questionnaire => {
                    ranges.push(...generateRanges(sampling, lastCompletion, questionnaire, now));
                });
            }

            questionnaireData.ids.push(...questionnaires.map((questionnaire => {
                questionnaireData[questionnaire.id] = questionnaire;

                return questionnaire.id;
            })));
        });

        const result = {
            samplings: samplingData,
            ranges,
            questionnaires: questionnaireData,
            loading: false,
        };


        window.Sentry.addBreadcrumbInfo("experiencesampling reducer", `resulting in ranges=${JSON.stringify(result.ranges)}`);

        return result;
    },
});



// WEBPACK FOOTER //
// ./scripts/frontend/base/reducer/experiencesampling.js